import { get, post, remove } from "utils/request";


export async function readAllAccountsReq(payload) {
  const {accessToken} = payload;
  return get(`/funded-accounts`, accessToken);
}